var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3BB0D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5C10.8955 5 10 5.89543 10 7C10 8.10457 10.8955 9 12 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.1616C10 12.1616 10 12.1616 10 12.1616C10 11.7605 10.2394 11.3962 10.621 11.2724C11.0281 11.1404 11.5637 11 12 11C12.4363 11 12.9719 11.1404 13.379 11.2724C13.7606 11.3962 14 11.7605 14 12.1616V17.8384C14 18.2395 13.7606 18.6038 13.379 18.7276C12.9719 18.8596 12.4363 19 12 19C11.5637 19 11.0281 18.8596 10.621 18.7276C10.2394 18.6038 10 18.2395 10 17.8384C10 17.8384 10 17.8384 10 17.8384C10 17.8382 10 16.1084 10 15C9.99998 13.8916 10 12.1618 10 12.1616Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.7a13a1c1fde38238eb48bebe85bfed47.svg";
export { ForwardRef as ReactComponent };